module.exports = __webpack_public_path__ + "static/media/slide-3-background-middle-mask.baca8b19.svg";